import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';
import { AuthLayout } from '../layouts/auth';
import { DefaultLayout } from '../layouts/default';
import { SuperAdminLayout } from '../layouts/super-admin';
import { ForgortPassword } from '../pages/Auth/ForgotPassword';
import { SignIn } from '../pages/Auth/SignIn';
import { Courses } from '../pages/Courses';
import Route from './Route';

import { NotFound404 } from '../components/NotFound404';

const Home = lazy(() => import('../pages/Home'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const BehaviorQuestions = lazy(() => import('../pages/Behaviour-Questions'));
const Brand = lazy(() => import('../pages/Brand'));
const Users = lazy(() => import('../pages/Users'));
const Perfil = lazy(() => import('../pages/Perfil'));
const Configurations = lazy(() => import('../pages/Configurations'));
const Grupos = lazy(() => import('../pages/Grupos'));
const Kandan = lazy(() => import('../pages/Grupos/Kandan'));
const EmailSender = lazy(() => import('../pages/Email-Sender'));
const ExternalLogin = lazy(() => import('../pages/ExternalLogin'));
const Game = lazy(() => import('../pages/Game'));
const ListaSimples = lazy(() => import('../pages/ListaSimples'));
const PlanilhasImportacao = lazy(() => import('../pages/PlanilhasImportacao'));

const Categories = lazy(() => import('../pages/Categories'));
const CategoriasDeChamados = lazy(() => import('../pages/Categorias-De-Chamados'));

const CompanyQuestionnaire = lazy(() => import('../pages/Company-Questionnaire'));
const QuestionnaireCategoryPage = lazy(() => import('../pages/QuestionnaireCategory'));
const CompanyQuiz = lazy(() => import('../pages/Company-Questionnaire/Kandan'));

const SuperAdmin = lazy(() => import('../pages/Super-Admin'));
const SuperAdminCourses = lazy(() => import('../pages/Super-Admin/Courses'));
const RamoEmpresaPage = lazy(() => import('../pages/Super-Admin/RamoEmpresa'));
const UseTermsSuperAdminPage = lazy(() => import('../pages/Super-Admin/Use-Terms'));
const Trilhas = lazy(() => import('../pages/Trilhas'));
const KanbanCursos = lazy(() => import('../pages/Trilhas/Kandan'));
const UseTermsPage = lazy(() => import('../pages/Use-Terms'));

const ComunicadosPage = lazy(() => import('../pages/Comunicados'));
const ComunicadosKanbanPage = lazy(() => import('../pages/Comunicados/Kanban'));

const BusinessUnit = lazy(() => import('../pages/Checklist'));
const ChecklistsKanban = lazy(() => import('../pages/Checklist/ChecklistsKanban'));
const KanbanTrilhaUnidades = lazy(() => import('../pages/Checklist/components/KanbanTrilha'));
const ChecklistValidation = lazy(() => import('../pages/Checklist-Validation'));
const ValidationForm = lazy(() => import('../pages/Checklist-Validation/Kanbam/FormValidation'));
const ChecklistSystemCategory = lazy(() => import('../pages/ChecklistCategories'));
const ChecklistCategoryList = lazy(() => import('../pages/ChecklistCategories/ChecklistCategoriesList'));
const SystemChecklistCategoryPage = lazy(() => import('../pages/SystemChecklistCategory'));

const RelatoriosLayout = lazy(() => import('../layouts/relatorios'));
// const RelatorioCursoPage = lazy(() => import('../pages/Relatorios/Cursos/Index'));
// const RelatorioQuestionarioPage = lazy(() => import('../pages/Relatorios/Questionarios/Index'));
// const RelatorioTrilhaPage = lazy(() => import('../pages/Relatorios/Trilha'));
const RelatorioChecklistPage = lazy(() => import('../pages/Relatorios/Checklist/Index'));
const ReportChecklist = lazy(() => import('../pages/Relatorios/Checklist/ReportChecklist'));
const ResearchReportPage = lazy(() => import('../pages/Relatorios/Research/index'));
const DashboardNpsPage = lazy(() => import('../pages/Relatorios/DashboardNps/Index'));
const DashboardChecklistPage = lazy(() => import('../pages/Relatorios/DashboardChecklist/Index'));

export const Routes: React.FC = () => (
  <Suspense fallback={<div>Carregando...</div>}>
    <Switch>
      <Route path="/" layout={AuthLayout} exact component={SignIn} />
      <Route path="/external-login" layout={AuthLayout} exact component={ExternalLogin} />
      <Route path="/forgot-password" layout={AuthLayout} exact component={ForgortPassword} />
      <Route path="/dashboard" isPrivate layout={DefaultLayout} exact component={Dashboard} />
      <Route path="/cursos" isPrivate layout={DefaultLayout} exact component={Courses} />
      <Route path="/grupo/:id" isPrivate layout={DefaultLayout} exact component={Kandan} />
      <Route
        path="/grupos/:ids+"
        isPrivate
        layout={DefaultLayout}
        exact
        component={Grupos}
      />
      <Route path="/grupos" isPrivate layout={DefaultLayout} exact component={Grupos} />
      <Route
        path="/unidades/:id/checklists"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ChecklistsKanban}
      />
      <Route path="/unidades/trilha/:id" isPrivate layout={DefaultLayout} exact component={KanbanTrilhaUnidades} />
      <Route path="/unidades/:ids+" isPrivate layout={DefaultLayout} exact component={BusinessUnit} />
      <Route path="/unidades" isPrivate layout={DefaultLayout} exact component={BusinessUnit} />
      <Route path="/categories" isPrivate layout={DefaultLayout} exact component={Categories} />
      <Route path="/inicio" isPrivate layout={DefaultLayout} exact component={Home} />
      <Route
        path="/categories/:categoryId/cursos"
        isPrivate
        layout={DefaultLayout}
        exact
        component={Trilhas}
      />
      <Route
        path="/categories/:categoryId/cursos/novo"
        isPrivate
        layout={DefaultLayout}
        exact
        component={KanbanCursos}
      />
      <Route
        path="/categories/:categoryId/cursos/:courseId"
        isPrivate
        layout={DefaultLayout}
        exact
        component={KanbanCursos}
      />
      <Route
        path="/categories/cursos-instalados"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ListaSimples}
      />
      <Route
        path="/pesquisas/trilha/:id"
        isPrivate
        layout={DefaultLayout}
        exact
        component={CompanyQuiz}
      />
      <Route
        path="/pesquisas/:ids+"
        isPrivate
        layout={DefaultLayout}
        exact
        component={CompanyQuestionnaire}
      />
      <Route
        path="/pesquisas"
        isPrivate
        layout={DefaultLayout}
        exact
        component={CompanyQuestionnaire}
      />
      <Route
        path="/categoria-checklist/checklist/:id"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ChecklistsKanban}
      />
      <Route
        path="/categoria-checklist/:id+"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ChecklistCategoryList}
      />
      <Route
        path="/categoria-checklist"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ChecklistSystemCategory}
      />
      <Route
        path="/comunicados/trilha/:id"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ComunicadosKanbanPage}
      />
      <Route
        path="/comunicados/:ids+"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ComunicadosPage}
      />
      <Route
        path="/comunicados"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ComunicadosPage}
      />
      <Route path="/validacoes" isPrivate layout={DefaultLayout} exact component={ChecklistValidation} />
      <Route path="/validacao/:id" isPrivate layout={DefaultLayout} exact component={ValidationForm} />
      <Route path="/usuarios" isPrivate layout={DefaultLayout} exact component={Users} />
      <Route path="/gamificacao" isPrivate layout={DefaultLayout} exact component={Game} />
      <Route path="/meuperfil" isPrivate layout={DefaultLayout} exact component={Perfil} />
      <Route path="/identidade-visual" isPrivate layout={DefaultLayout} exact component={Brand} />
      <Route path="/envio-de-emails" isPrivate layout={DefaultLayout} exact component={EmailSender} />
      <Route
        path="/categorias-de-chamados"
        isPrivate
        layout={DefaultLayout}
        exact
        component={CategoriasDeChamados}
      />
      <Route
        path="/termos-de-uso"
        roles={['Sistema']}
        isPrivate
        layout={DefaultLayout}
        exact
        component={UseTermsPage}
      />
      {/* Relatórios comentados temporariamente a pedido do Gabriel 08/04/25 */}
      {/* <Route
        path="/relatorios/trilha"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={RelatorioTrilhaPage}
      /> */}
      {/* <Route
        path="/relatorios/cursos"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={RelatorioCursoPage}
      /> */}
      {/* <Route
        path="/relatorios/questionarios"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={RelatorioQuestionarioPage}
      /> */}
      <Route
        path="/relatorios/checklist"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={RelatorioChecklistPage}
      />
      <Route
        path="/relatorios/checklist/:id"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={ReportChecklist}
      />
      <Route
        path="/relatorios/dashboard-checklist"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={DashboardChecklistPage}
      />
      <Route
        path="/relatorios/dashboard-nps"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={DashboardNpsPage}
      />
      <Route
        path="/report-research/:id"
        isPrivate
        layout={DefaultLayout}
        exact
        component={ResearchReportPage}
      />
      <Route
        path="/super-admin/empresas"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={SuperAdmin}
      />
      <Route
        path="/super-admin/cursos"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={SuperAdminCourses}
      />
      <Route
        path="/super-admin/perguntas-comportamentais"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={BehaviorQuestions}
      />
      <Route
        path="/super-admin/questionario-categoria/:ids+"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={QuestionnaireCategoryPage}
      />
      <Route
        path="/super-admin/questionario-categoria"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={QuestionnaireCategoryPage}
      />
      <Route
        path="/super-admin/checklist-categoria"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={SystemChecklistCategoryPage}
      />
      <Route
        path="/super-admin/ramos"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={RamoEmpresaPage}
      />
      <Route
        path="/super-admin/configuracoes"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={Configurations}
      />
      <Route
        path="/super-admin/planilhas"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={PlanilhasImportacao}
      />
      <Route
        path="/super-admin/termos-de-uso"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={UseTermsSuperAdminPage}
      />
      <Route
        path="/relatorios"
        isPrivate
        layout={RelatoriosLayout}
        exact
        component={RelatorioChecklistPage}
      />
      <Route
        path="/super-admin"
        roles={['Sistema']}
        isPrivate
        layout={SuperAdminLayout}
        exact
        component={SuperAdmin}
      />
      <Route path="/404" isPrivate layout={DefaultLayout} exact component={NotFound404} />
    </Switch>
  </Suspense>
);
